import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button, Collapse, Nav, Navbar, NavLink } from "react-bootstrap";
import ObjectUtils, { coalesce } from "../../../utils/ObjectUtils";
import { visibleCollection } from "../../../utils/TriggerUtil";

const { getDeepProperty } = ObjectUtils;

/**
 * Overview component for survey-view. Represents left side on runner where user can see overview with structure of
 * pages of survey.
 */
const Overview = ({
  intl,
  jumpToPage,
  showHideOverview,
  showOverviewMenu,
  surveyCurrentPage,
  surveyFundingArea,
  surveyName,
  surveyProgram,
  surveyTemplate,
  triggerState
}) => {
  const menuItem = (page, i) => {
    const title = page.title || page.name;
    const selected = page.name === surveyCurrentPage;
    return (
      <NavLink
        key={i}
        active={selected}
        onClick={() => {
          jumpToPage(page.name);
        }}
      >
        {`${i + 1}. ${title}`}
      </NavLink>
    );
  };

  const visiblePages = visibleCollection(surveyTemplate.pages, triggerState);

  /* Check if funding area and program presented, otherwise print all funding area */
  const label = `${coalesce(
    getDeepProperty(surveyFundingArea, "name"),
    intl.formatMessage({ id: "user.surveyBuilder.program" })
  )} / ${coalesce(getDeepProperty(surveyProgram, "name"), "")}`;

  return (
    <>
      <h5>{surveyName}</h5>
      <h6 className="my-3">{label}</h6>
      <div
        style={{
          position: "sticky",
          top: "1.5rem"
        }}
      >
        <Button size="sm" variant="secondary" className="text-start w-100" onClick={() => showHideOverview()}>
          <FontAwesomeIcon icon={showOverviewMenu ? faAngleDown : faAngleRight} className="me-2" />
          <FormattedMessage id="user.surveyView.menuPages" />
        </Button>
        <Collapse in={showOverviewMenu}>
          <Navbar variant="light" bg="light">
            <Nav className="flex-column overflow-y-auto">{visiblePages.map((p, i) => menuItem(p, i))}</Nav>
          </Navbar>
        </Collapse>
      </div>
    </>
  );
};

Overview.propTypes = {
  surveyName: PropTypes.string,
  surveyFundingArea: PropTypes.object,
  surveyProgram: PropTypes.object,
  surveyCurrentPage: PropTypes.string,
  surveyTemplate: PropTypes.object.isRequired,
  showHideOverview: PropTypes.func,
  showOverviewMenu: PropTypes.bool,
  triggerState: PropTypes.array,
  jumpToPage: PropTypes.func
};

export default injectIntl(Overview);
